define((require) => {
    "use strict";

    const generate = require("nanoid/generate");
    const uuidAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz-";

    return {
        createUUID(uuid) {
            uuid = uuid && uuid.length > 0 ? uuid : generate(uuidAlphabet, 21);
            return uuid;
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/UUIDGenerator.js